import { render, staticRenderFns } from "./headercommon.vue?vue&type=template&id=1bbb0350"
import script from "./headercommon.vue?vue&type=script&lang=js"
export * from "./headercommon.vue?vue&type=script&lang=js"
import style0 from "./headercommon.vue?vue&type=style&index=0&id=1bbb0350&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports